var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vModal vModalDefault", class: _vm.$style.dialog },
    [
      _c("div", { class: _vm.$style.header }, [
        _c("img", {
          class: _vm.$style.headerIcon,
          attrs: { src: require("images/ui/icon-warning.svg"), alt: "Warning" },
        }),
        _c("div", [
          _c("h2", { class: _vm.$style.headerSub }, [
            _c("span", { class: _vm.$style.headerSubText }, [
              _vm._v("You have uploaded " + _vm._s(_vm.uploadedCountText)),
            ]),
          ]),
          _c("h1", { class: _vm.$style.headerMain }, [
            _c("span", { class: _vm.$style.headerMainText }, [
              _vm._v(_vm._s(_vm.errorsCountText)),
            ]),
          ]),
        ]),
        _c(
          "button",
          {
            staticClass: "vModalDefaultCloseButton",
            on: {
              click: function ($event) {
                return _vm.hide()
              },
            },
          },
          [_vm._v(" close ")]
        ),
      ]),
      _c("div", { class: _vm.$style.modalBody }, [
        _vm.side === "SUPPLIER"
          ? _c("div", { class: _vm.$style.bodyText }, [
              _c("h2", { staticStyle: { color: "red", margin: "10px 0" } }, [
                _vm._v("BUT YOU HAVE NOT SENT THE BIDS"),
              ]),
              _vm._m(0),
              _c(
                "div",
                { staticStyle: { color: "black", "margin-top": "10px" } },
                [
                  _vm._v(
                    " Remember This... IF you can see the Rates (static or dynamic) on the Bid Manager so can your customer "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "vModalDefaultFooter" },
        [
          _vm._t("footer", function () {
            return [
              _vm.side === "SUPPLIER"
                ? _c("div", { staticStyle: { "text-align": "left" } }, [
                    _vm._m(1),
                  ])
                : _c(
                    "button",
                    {
                      staticClass: "rbButton mainButton",
                      class: _vm.$style.okButton,
                      on: {
                        click: function ($event) {
                          return _vm.hide()
                        },
                      },
                    },
                    [_vm._v(" OK ")]
                  ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "line-height": "18px" } }, [
      _vm._v(
        ' To send bids to customer, you need to select ALL Hotels and Click SEND BIDS. If Bid Status shows "Bid Incomplete" you may want to check the box, then select Edit or Update bid on very top... Then Send.'
      ),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { "data-icon-before": "help" } }, [
      _c(
        "a",
        {
          staticStyle: { "font-size": "13px", "margin-left": "5px" },
          attrs: { href: "https://invis.io/F6ZMRMAP7ST", target: "_blank" },
        },
        [_vm._v(" Upload Tutorial ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }